import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import { Redirect } from 'react-router-dom';

import TopBar from "../components/TopBar";
import Sidebar from "../components/Sidebar";

import ComplianceGantt from "../components/Gantt/ComplianceGantt";  // Assuming same Gantt component works

function ComplianceGanttPage(props) {
    const { token, activeComplianceId, activeComplianceStandard } = props;
    const collapsed = false;
    
    return token ? (
        <div className="flex flex-col w-full h-screen overflow-x-hidden">
          {/* TopBar */}
          {!activeComplianceId && (
            <TopBar className="fixed top-0 left-0 right-0 z-10" />
          )}
    
          <div className="flex flex-row w-full h-full">
            {/* Sidebar */}
            {!activeComplianceId && (
              <Sidebar collapsed={collapsed} className="fixed top-0 left-0 h-screen pt-[64px] z-0" />
            )}
    
            {/* Main content */}
            <div
              id="dashboard-content"
              className={`flex flex-col h-full overflow-y-auto p-4 transition-all duration-300 ${
                !activeComplianceId ? (collapsed ? "ml-16" : "ml-64") : ""
              }`}
            >
              {/* Gantt container with its own horizontal scroll */}
              <div className="overflow-x-auto w-full h-full">
                <ComplianceGantt activeComplianceId={activeComplianceId} />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Redirect to="/login" />
      );
    }

const mapStateToProps = (state) => {
    return {
        token: state.auth.token,
        activeComplianceId: state.compliance.activeComplianceId,
    };
};

export default compose(connect(mapStateToProps))(ComplianceGanttPage);